import { create } from 'zustand'
import axios from 'axios'

export const API_SLUG = 'SaleOrder/:id/items'

export const INITIAL_STATE = {
  id: null,
  itemCode: '',
  itemTitle: '',
  quantity: 0,
  hammerMethod: '',
  //'2023-08-30T00:00:00'
  createdAt: null,
  updatedAt: null,
  saleOrderId: 0,
  saleOrder: null,
}
interface SaleOrderItemStore {
  create: (id: string, data: any) => Promise<{ success: boolean; data: any }>
  update: (id: string, itemId: string, data: any) => Promise<{ success: boolean; data: any }>
  addUpdate: (id: string, data: any[]) => Promise<{ success: boolean; data: any }>
  delete: (id: string, itemId: string) => Promise<{ success: boolean; data: any }>
}

export const useSaleOrderItemStore = create<SaleOrderItemStore>((set, get) => ({
  create: async (id, data) => {
    const formData = new FormData()
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined) {
        formData.append(`piles[][${key}]`, data[key])
      }
    })

    return axios
      .patch(`/${API_SLUG.replace(':id', id)}`, formData)
      .then(res => {
        return { success: true, data: res.data }
      })
      .catch(err => {
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  update: async (id, itemId, data) => {
    const formData = new FormData()
    data.forEach((item: any, idx: number) => {
      if (item !== undefined) {
        formData.append(`piles[${idx}][itemCode]`, data['itemCode'])
        formData.append(`piles[${idx}][]`, data['itemTitle'])
        formData.append(`piles[${idx}][]`, data['quantity'])
        formData.append(`piles[${idx}][]`, data['actualQuantity'])
        formData.append(`piles[${idx}][]`, data['groupLetter'])
        formData.append(`piles[${idx}][]`, data['remark'])
        formData.append(`piles[${idx}][]`, data['safeLoad'])
        formData.append(`piles[${idx}][]`, data['ps'])
        formData.append(`piles[${idx}][]`, data['sequence'])
        formData.append(`piles[${idx}][]`, data['factory'])
      }
    })

    return axios
      .patch(`/${API_SLUG.replace(':id', id)}/${itemId}`, formData)
      .then(res => {
        return { success: true, data: res.data }
      })
      .catch(err => {
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  addUpdate: async (id, data) => {
    const formData = new FormData()

    if (data.length > 0) {
      data.forEach((item: any, idx: number) => {
        if (item !== undefined) {
          formData.append(`piles[${idx}][itemCode]`, item.itemCode)
          formData.append(`piles[${idx}][itemTitle]`, item.itemTitle)
          formData.append(`piles[${idx}][quantity]`, item.quantity)
          formData.append(`piles[${idx}][actualQuantity]`, item.actualQuantity)
          formData.append(`piles[${idx}][groupLetter]`, item.groupLetter)
          formData.append(`piles[${idx}][remark]`, item.remark || '')
          formData.append(`piles[${idx}][safeLoad]`, item.safeLoad || '')
          formData.append(`piles[${idx}][ps]`, item.ps || '')
          formData.append(`piles[${idx}][sequence]`, item.sequence)
          formData.append(`piles[${idx}][factory]`, item.factory || '')
        }
      })
    }

    return axios
      .put(`/${API_SLUG.replace(':id', id)}`, formData)
      .then(res => {
        return { success: true, data: res.data }
      })
      .catch(err => {
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  delete: async (id, itemId) => {
    return axios
      .delete(`/${API_SLUG.replace(':id', id)}/${itemId}`)
      .then(res => {
        return { success: true, data: res.data }
      })
      .catch(err => {
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
}))
